import { cx } from "class-variance-authority";
import type { PropsWithChildren } from "react";
import {
  OverlayArrow as AriaOverlayArrow,
  Tooltip as AriaTooltip,
  type TooltipProps as AriaTooltipProps,
  TooltipTrigger as AriaTooltipTrigger,
} from "react-aria-components";

import { PointerHorizontalIcon } from "@/assets/icons/ui/PointerHorizontal";
import { PointerVerticalIcon } from "@/assets/icons/ui/PointerVertical";
import { Typography } from "@/components/ui/text/Typography/Typography";

type TooltipProps = PropsWithChildren &
  AriaTooltipProps & {
    text?: string;
    tooltipContent?: React.ReactNode;
    hideArrow?: boolean;
    bgColor?: string;
    arrowColor?: string;
    tooltipContentClassName?: string;
  };

export const Tooltip = ({
  children,
  text,
  hideArrow = false,
  bgColor = "bg-secondary-300",
  arrowColor = "text-secondary-300",
  tooltipContent,
  tooltipContentClassName,
  ...tooltipProps
}: TooltipProps) => {
  return (
    <AriaTooltipTrigger
      delay={0}
      closeDelay={0}
      isDisabled={!text && !tooltipContent}
    >
      {children}
      <AriaTooltip
        className={cx(
          "group max-w-64 rounded-xs border border-secondary-200 px-3 py-2 shadow-5",
          bgColor,
          tooltipContentClassName,
        )}
        {...tooltipProps}
        offset={13}
      >
        {!hideArrow && (
          <AriaOverlayArrow>
            <PointerHorizontalIcon
              className={cx(
                "h-2-5 w-5 group-data-[placement=left]:hidden group-data-[placement=right]:hidden group-data-[placement=top]:rotate-180",
                arrowColor,
              )}
            />
            <PointerVerticalIcon
              className={cx(
                "h-5 w-2-5 group-data-[placement=bottom]:hidden group-data-[placement=top]:hidden group-data-[placement=left]:rotate-180",
                arrowColor,
              )}
            />
          </AriaOverlayArrow>
        )}
        <Typography
          size="labels-lg"
          className="text-secondary-50"
        >
          {text}
        </Typography>
        {tooltipContent}
      </AriaTooltip>
    </AriaTooltipTrigger>
  );
};
